import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse, ApprovalFlow } from '../models/api-response.model';

export interface ApprovalFlowPayload {
  module_name: string;
  flow_name: string;
  description: string | null;
  approval_levels: number;
  final_approval_authority_user_id: number;
  levels: Array<{
    level_no: number;
    approver_user_id: number;
  }>;
}

@Injectable({ providedIn: 'root' })
export class ApprovalFlowService {
  private readonly http = inject(HttpClient);

  list(): Observable<ApiResponse<ApprovalFlow[]>> {
    return this.http.get<ApiResponse<ApprovalFlow[]>>(API_ENDPOINTS.approvalFlows);
  }

  create(payload: ApprovalFlowPayload): Observable<ApiResponse<ApprovalFlow>> {
    return this.http.post<ApiResponse<ApprovalFlow>>(API_ENDPOINTS.approvalFlows, payload);
  }
}
